import { useEffect, useState } from "react";
import { Card, Row, Col, Layout, Space, Typography } from "antd";
import { useParams, useHistory } from "react-router-dom";
import { getAdminPath } from "../../../../util/router";
import { useQuery } from "@apollo/client";
import { useIntl } from "react-intl";
import CircularProgress from "../../../../components/CircularProgress";
import { GQL_CUSTOMER_PUBLIC_AREA_INFO } from "../../../../apollo/query/customer-public-area";
import IntlMessages from "../../../../util/IntlMessages";
import CustomerPublicFacilitiesList from "./list";
import { PublicFacilitiesContext } from "./context";
import CustomerPublicFacilitiesForm from "./form";
import { sortTaxAccountsByCode } from "./functions";

const { Header, Content } = Layout;
const { Title } = Typography;

const CustomerPublicFacilitiesContent = ({ data, refetch, token }) => {
   const intl = useIntl();
   const [selectedItem, setSelectedItem] = useState(null);
   const { customer, waste_bin_types, unit_measure_types, form } = data || {};
   const { company_name, fiscal_code, tax_accounts } = customer || {};

   useEffect(() => {
      setSelectedItem({
         ...selectedItem,
         waste_bin_types,
         unit_measure_types,
      });
   }, [waste_bin_types, unit_measure_types]);

   const sortedTaxAccounts = sortTaxAccountsByCode(tax_accounts);

   return (
      <PublicFacilitiesContext.Provider value={{ selectedItem, setSelectedItem }}>
         <Layout style={{ minHeight: "100vh" }}>
            <Header
               style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#fff",
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 24px",
               }}
            >
               <a href="https://www.risparmiotari.it" rel="noopener noreferrer">
                  <img
                     alt={process.env.REACT_APP_NAME}
                     src="/assets/images/logo-with-name.png"
                     height={34}
                  />
               </a>
               <Space direction="vertical" size={0}>
                  <Title level={4} style={{ margin: 0 }}>
                     {company_name}
                  </Title>
                  <div className="gx-text-right">
                     <small>{fiscal_code}</small>
                  </div>
               </Space>
            </Header>
            <Content style={{ padding: 24 }}>
               <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                  <Col span={24}>
                     <Card
                        className="gx-card"
                        title={
                           <Title
                              level={3}
                              className="gx-mb-0"
                              style={{ textTransform: "none" }}
                           >
                              <IntlMessages id="customer.compile_public_facilities_p" />
                           </Title>
                        }
                     >
                        <Row gutter={[16, 16]}>
                           <Col xs={24}>
                              <p>
                                 {intl.formatMessage({
                                    id: "customer.compile_public_facilities_p2",
                                 })}
                              </p>
                           </Col>
                        </Row>
                        <Row gutter={[16, 16]} className="gx-mt-4">
                           <Col xs={24} lg={5}>
                              <CustomerPublicFacilitiesList
                                 taxAccounts={sortedTaxAccounts}
                                 form={form}
                              />
                           </Col>
                           <Col xs={24} lg={19}>
                              <CustomerPublicFacilitiesForm
                                 taxAccounts={sortedTaxAccounts}
                                 form={form}
                                 refetch={refetch}
                                 token={token}
                              />
                           </Col>
                        </Row>
                     </Card>
                  </Col>
               </Row>
            </Content>
         </Layout>
      </PublicFacilitiesContext.Provider>
   );
};

const CustomerPublicFacilities = () => {
   const history = useHistory();
   const { token } = useParams();
   const { data, error, loading, refetch } = useQuery(
      GQL_CUSTOMER_PUBLIC_AREA_INFO,
      {
         context: {
            headers: {
               "x-rt-customer-public-token": token,
            },
         },
         fetchPolicy: "no-cache",
      }
   );

   if (!token || token.trim() === "" || error) {
      console.log(error);
      history.push(getAdminPath("/"));
      return null;
   }

   if (loading) {
      return <CircularProgress />;
   }

   return (
      <CustomerPublicFacilitiesContent
         token={token}
         data={data?.customerPublicAreaInfo}
         refetch={refetch}
      />
   );
};

export default CustomerPublicFacilities;
